<template>
  <div>
    <single-select
      class="form"
      :options="options"
      :value.sync="compValue"
      :value-property="'value'"
      :disabled="readonly"
    />
    <span v-if="modelstate.length > 0" class="text-danger">
      {{ modelstate }}
    </span>
    <span class="text-danger" v-if="modelstate['ReasonId']">
      {{ "*" + modelstate["ReasonId"][0] }}
    </span>
  </div>
</template>

<script>
export default {
  name: "vehicleAvailableReasonDropDown",
  components: {
    "single-select": () => import("@/components_rms/base/SingleSelect.vue"),
  },
  props: {
    vehicleAvailableReasonId: Number,
    vehicleAvailable: Boolean,
    modelstate: Object,
    readonly: Boolean,
  },
  data() {
    return {
      modelstate: {},
      options: [],
    };
  },
  created() {
    this.getList();
  },
  computed: {
    compValue: {
      get: function () {
        return this.vehicleAvailableReasonId;
      },
      set: function (newValue) {
        this.$emit("update:vehicleAvailableReasonId", newValue);
      },
    },
  },
  watch: {
    vehicleAvailable: {
      handler(newValue) {
        this.$emit("update:vehicleAvailable", newValue);
      },
    },
  },
  methods: {
    getList: function () {
      this.modelstate = {};
      let reason;

      if (this.vehicleAvailable) {
        reason = 1; // Esta ativado e quer desativar
      } else {
        reason = 2; // Esta desativado e quer ativar
      }

      this.$apiVehicle
        .post(`/vehicleAvailableReason/get/list/${reason}`)
        .then((response) => {
          this.options = response.data.map((item) => ({
            value: item.id,
            text: item.name,
          }));
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
  },
};
</script>